import React from 'react';
import { useSelector } from 'react-redux';
import { getDefaultformFields } from '../utilities/form-utilities';
import { countryList, optInList } from '../files/marketo-data';
import { get, getText } from '../../../helpers';
import APIManager from '../../../utilities/api-manager';

const RequestTrialForm = React.lazy(() => import('../index' /* webpackChunkName: "request-a-trial-form" */));
const formText = getText('pages.requestTrial');
const getSubmissionBody = (
    productName: string,
    data: RequestATrialState,
) => {
    const body: RATIHSMarkitRequest = {
        FirstName: data.FirstName,
        LastName: data.LastName,
        Country: data.Country as string,
        State: data.State as string,
        City: data.City,
        PostalCode: data.PostalCode,
        Email: data.Email,
        Phone: data.Phone,
        Company: data.Company,
        CompanyType: data.CompanyType as string,
        JobFunction: data.JobFunction as string,
        FormTitle: productName,
        SourceUrl: window.location.href,
        Comments: data.OtherInterest,
        OptInSelection: data.HasUserConsent ? 'on' : '',
        OptIn: optInList.includes(data.Country as string) ? '1' : '0',
        AreaofInterest: `${formText.interestSectionTitle}: ${data.InterestArea.replace(',', '|')}`,
        UTMParams: ''
    };
    return body;
};

const getUTMParamString = (utmParameters: UTMParameters) => {
    let utmString = '';
    if (utmParameters.utmSource) {
        utmString = `${utmString}utm_source=${utmParameters.utmSource}&`;
    }
    if (utmParameters.utmMedium) {
        utmString = `${utmString}utm_medium=${utmParameters.utmMedium}&`;
    }
    if (utmParameters.utmCampaign) {
        utmString = `${utmString}utm_campaign=${utmParameters.utmCampaign}&`;
    }
    if (utmParameters.utmTerm) {
        utmString = `${utmString}utm_term=${utmParameters.utmTerm}&`;
    }
    if (utmParameters.utmContent) {
        utmString = `${utmString}utm_content=${utmParameters.utmContent}&`;
    }
    if (utmString.length > 0) utmString = utmString.substring(0, utmString.length - 1);
    return utmString;
};

const submitForm = (
    requestBody: RATIHSMarkitRequest,
    cb: () => void,
    error: (error: string) => void
) => {

    APIManager.submitLeadToEloqua(requestBody).then(response => {
        if (response.data) {
            cb();
            return;
        }
        error('Eloqua request  failed');
    }).catch(() => error('Eloqua request  failed'));
};

function RequestTrialIHSMarkit(props: RequestATrialFormProps) {
    const { productName = '', productVariant, titleText, ratVariant } = props;
    const { isLoggedIn } = useSelector((state: RootStoreState) => get(state, 'user'));
    const { countries } = useSelector((state: RootStoreState) => get(state, 'filters'));
    const { utmParameters } = useSelector((state: RootStoreState) => get(state, 'shared'));

    const getCoutries = () => {
        if (isLoggedIn) {
            return countries
                ? (countries.map((country: Country) => {
                    return { text: country.CountryShortName, id: country.KeyCountry };
                }) as StringNumberIDObject[])
                : [];
        }
        return countryList as StringNumberIDObject[];
    };
    const getCountryCodeByName = (countryName: string) => {
        const country = getCoutries().find((item: StringNumberIDObject) => {
            return item.text === countryName;
        });
        return country ? country.value || country.id.toString() : '';
    };

    const onSubmit = (
        data: RequestATrialState,
        cb: () => void,
        error: (error: string) => void
    ) => {
        const requestBody = getSubmissionBody(productName, data);
        requestBody.Country = getCountryCodeByName(requestBody.Country);
        requestBody.UTMParams = getUTMParamString(utmParameters);
        requestBody.AreaofInterest = `${requestBody.AreaofInterest} UTMparameters:{${requestBody.UTMParams}}`;
        submitForm(requestBody, cb, error);
    };
    const defaultFormTextFields = getDefaultformFields();
    return (
        <RequestTrialForm onSubmitForm={onSubmit} formTextFields={defaultFormTextFields} productVariant={productVariant} titleText={titleText} ratVariant={ratVariant} />
    );
}

export default React.memo(RequestTrialIHSMarkit);
